import PropTypes from 'prop-types'
import React from 'react'
import { canUser } from '../../../../common/utils/userAuthorization'

class AdminLink extends React.Component {
  static propTypes = {
    user: PropTypes.object
  }

  render () {
    const { user } = this.props

    if (canUser(user, 'canViewAdmin')) {
      return (
        <li className='global-header-menu__list-item'>
          <a href='/admin' className='global-header-menu__link'>
            <span className='global-header-menu__link-text'>
              Admin
            </span>
          </a>
        </li>
      )
    } else {
      return null
    }
  }
}

export default AdminLink



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/adminLink.js